import * as swcHelpers from '@swc/helpers';
import { reducer as reducer$1, actions } from '@grandvisionhq/state';
import { updateActiveVariant } from './actions.js';

const initialState = {
    activeSku: ''
};
const productDetailContextReducer = reducer$1(initialState, actions.on(updateActiveVariant, (state, action)=>swcHelpers.objectSpread({}, state, {
        activeSku: action.payload.sku
    })
));

export { initialState, productDetailContextReducer };
//# sourceMappingURL=reducer.js.map
